/*
 * Lista de períodos letivos para os selects de ano das telas.
 *
 * ==================== POR QUE ESTE ARQUIVO EXISTE ====================
 *
 * Trinta e quatro telas repetiam, no `mounted`, duas linhas erradas:
 *
 *     this.periodos = this.$store.state.config.periodos || []
 *     if (!this.periodos.length && this.$store.state.config.periodo)
 *         this.periodos = [this.$store.state.config.periodo]
 *
 * Dois defeitos somados:
 *
 * 1. `state.config` guarda apenas o período CORRENTE (`config.periodo`). A lista completa
 *    vive em `state.periodos`, preenchida por `initSistema`. Lendo do lugar errado, a
 *    primeira linha sempre resultava em `[]` e a segunda tomava conta — o select passava a
 *    oferecer um único ano.
 *
 * 2. Ler no `mounted` é cedo demais. O `layout` dispara `getUser()` no PRÓPRIO `mounted`,
 *    que em Vue 2 roda DEPOIS do `mounted` dos filhos — numa carga direta da URL (F5), a
 *    tela lê o store antes de `initSistema` responder. Uma cópia feita ali nunca é
 *    atualizada.
 *
 * Por isso é um `computed`, e não uma atribuição: quando `initSistema` responde, os selects
 * se preenchem sozinhos. `state.periodos` chega do backend indexado por id, não como array
 * — daí o `Object.values`.
 */

export const periodosLetivosMixin = {
  computed: {
    periodos () {
      const p = this.$store.state.periodos || {}
      return Object.values(p).sort((a, b) => String(b.nome).localeCompare(String(a.nome)))
    }
  }
}

export default periodosLetivosMixin
